import React from "react";
import {
  Form,
  Grid,
  Card,
  Button,
  Icon,
  Page
} from "tabler-react";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux';
import SiteWrapperSuperAdmin from "../../SiteWrapper.superadmin.react";
import { validate } from '../../../validate';
import { createDoctor, getAllAppointmentModes, getAllHospitals, getAllSpecializations } from "../../../services/hospital";
import authActions from "../../../redux/auth/action";
import Buttonloader from '../../../common/Loader/Buttonloader'
import { changeLanguage } from '../../../language/index';
import SiteWrapperHospitalSuperadminReact from "../SiteWrapper.hospital.superadmin.react";

const validationRules = [
  {
    field: 'name_en',
    validations: ['required'],
    name: 'Name'
  },
  {
    field: 'name_id',
    validations: ['required'],
    name: 'Name Id'
  },
  {
    field: 'id',
    validations: ['required'],
    name: 'Id'
  },
  {
    field: 'hospital_id',
    validations: ['required'],
    name: 'Hospital'
  },
  {
    field: 'appointment_id',
    validations: ['required'],
    name: 'Appointment'
  },
  {
    field: 'specialization_id',
    validations: ['required'],
    name: 'Specialization'
  },
];

class DoctorCreate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: [{
        name_en: '',
        name_id: '',
        id: '',
        hospital_id: '',
        appointment_id: '',
        specialization_id: ''
      }],
      hospitalArr: [],
      appointmentArr: [],
      specializationArr: [],
      isLoading: false,
      message: {
        style: 'success',
        text: ''
      },
      errors: {},
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.setLoadingToggle = this.setLoadingToggle.bind(this);
    this.addDoctor = this.addDoctor.bind(this);
    this.removeDoctor = this.removeDoctor.bind(this);

  }


  //handle change
  handleChange = (e, field, index = null) => {
    if (index != null) {
      const { fields } = this.state,
        val = e.target.value;
      fields[index][field] = val;
      this.setState({ fields });
    }
  }


  addDoctor = () => {
    const { fields } = this.state;
    fields.push({
      name_en: '',
      name_id: '',
      id: '',
      hospital_id: '',
      appointment_id: '',
      specialization_id: ''
    })
    this.setState({ fields })
  }
  removeDoctor = (index) => {
    const { fields } = this.state;
    let arr = fields.filter((el, i) => i != index)
    console.info(arr)
    this.setState({ fields: arr })
  }

  setLoadingToggle(value) {
    this.setState({ isLoading: value })
  }

  //submit form
  handleSubmit = async event => {
    event.preventDefault();

    if (this.validate()) {
      this.setLoadingToggle(true);
      let data = this.state.fields
      console.log(data)
      createDoctor(data)
        .then(response => {
          toast.success("Doctor created successfully.")
          setTimeout(() => {
            this.props.history.push("/admin/hospitaltabs/doctor/1");
          }, 3000)
        })
        .catch(error => {
          if (error.response && error.response.data.message)
            toast.error(error.response.data.message)
          else if (error.message)
            toast.error(error.message)
          else
            toast.error(error)
          this.setLoadingToggle(false);
        })

    }
  }


  validate() {
    const { fields } = this.state;
    let validateObj = {}
    let validationRulesForArray = []
    fields.forEach((el, i) => {
      for (const property in el) {
        validateObj[property + i] = el[property]
        let ruleObj = validationRules.find(elx => elx.field == property)
        let newRuleObj = { ...ruleObj, field: property + i }
        validationRulesForArray.push(newRuleObj)
      }
    })
    const { isValid, errors } = validate(validateObj, validationRulesForArray);
    this.setState({ errors });
    console.info(errors)
    return isValid;
  }

  componentDidMount() {
    document.title = "Voiceoc | Create Doctor";
    getAllHospitals()
      .then(res => {
        console.info(res)
        this.setState(() => ({
          hospitalArr: res.data.result,
        }));
      }).catch(err => console.error(err))
    getAllAppointmentModes()
      .then(res => {
        console.info(res)
        this.setState(() => ({
          appointmentArr: res.data.result,
        }));
      }).catch(err => console.error(err))
    getAllSpecializations()
      .then(res => {
        console.info(res)
        this.setState(() => ({
          specializationArr: res.data.result,
        }));
      }).catch(err => console.error(err))



  }
  render() {

    return (


      <SiteWrapperHospitalSuperadminReact>
        <Page.Content>
          <Grid.Row>
            <Grid.Col lg={5} className="mx-auto ">
              <Card>
                <Card.Header>
                  <Card.Title>{changeLanguage(this.props.siteLanguage, 'add_doctor')}</Card.Title>
                </Card.Header>
                <Card.Body>
                  <form onSubmit={this.handleSubmit}>
                    {this.state.fields.map((el, i) => (
                      <div className="loop-form-spacing">
                        <Form.FieldSet>
                          <Form.Group
                            isRequired
                            label={changeLanguage(this.props.siteLanguage, 'name_en')}
                          >
                            <Form.Input name="name_en"
                              onChange={(e) => this.handleChange(e, 'name_en', i)}
                              placeholder={changeLanguage(this.props.siteLanguage, 'name_en')}
                              value={el.name_en} />
                            <label style={{ display: this.state.errors["name_en" + i] ? 'block' : 'none' }} className="error">{this.state.errors["name_en" + i]}</label>
                          </Form.Group>

                          <Form.Group
                            isRequired
                            label={changeLanguage(this.props.siteLanguage, 'name_id')}
                          >
                            <Form.Input name="name_id"
                              onChange={(e) => this.handleChange(e, 'name_id', i)}
                              placeholder={changeLanguage(this.props.siteLanguage, 'name_id')}
                              value={el.name_id} />
                            <label style={{ display: this.state.errors["name_id" + i] ? 'block' : 'none' }} className="error">{this.state.errors["name_id" + i]}</label>
                          </Form.Group>
                          <Form.Group
                            isRequired
                            label={changeLanguage(this.props.siteLanguage, 'doctor_id')}
                          >
                            <Form.Input name="Id"
                              onChange={(e) => this.handleChange(e, 'id', i)}
                              placeholder={changeLanguage(this.props.siteLanguage, 'doctor_id')}
                              value={el.id} />
                            <label style={{ display: this.state.errors["id" + i] ? 'block' : 'none' }} className="error">{this.state.errors["id" + i]}</label>
                          </Form.Group>


                          <Form.Group
                            isRequired
                            label={changeLanguage(this.props.siteLanguage, 'hospital')}
                          >
                            <Form.Select
                              name={changeLanguage(this.props.siteLanguage, 'hospital')}
                              onChange={(e) => this.handleChange(e, 'hospital_id', i)}
                              value={el.hospital_id}
                            >
                              <option value="">
                                {changeLanguage(this.props.siteLanguage, 'please_select_hospital')}
                              </option>
                              {
                                this.state.hospitalArr && this.state.hospitalArr.length && this.state.hospitalArr.map(el => (
                                  <option value={el.id}>{el.name_en}</option>
                                ))
                              }
                            </Form.Select>
                            <label style={{ display: this.state.errors["hospital_id" + i] ? 'block' : 'none' }} className="error">{this.state.errors["hospital_id" + i]}</label>
                          </Form.Group>



                          <Form.Group
                            isRequired
                            label={changeLanguage(this.props.siteLanguage, 'appointment_mode')}
                          >
                            <Form.Select
                              name={changeLanguage(this.props.siteLanguage, 'appointment_mode')}
                              onChange={(e) => this.handleChange(e, 'appointment_id', i)}
                              value={el.appointment_id}
                            >
                              <option value="">
                                {changeLanguage(this.props.siteLanguage, 'please_select_appointment_mode')}
                              </option>
                              {
                                this.state.appointmentArr && this.state.appointmentArr.length && this.state.appointmentArr.filter(elx => elx.hospital_id == el.hospital_id).map(el => (
                                  <option value={el.id}>{el.name_en}</option>
                                ))
                              }
                            </Form.Select>
                            <label style={{ display: this.state.errors["appointment_id" + i] ? 'block' : 'none' }} className="error">{this.state.errors["appointment_id" + i]}</label>
                          </Form.Group>

                          <Form.Group
                            isRequired
                            label={changeLanguage(this.props.siteLanguage, 'specialization')}
                          >
                            <Form.Select
                              name={changeLanguage(this.props.siteLanguage, 'specialization')}
                              onChange={(e) => this.handleChange(e, 'specialization_id', i)}
                              value={el.specialization_id}
                            >
                              <option value="">
                                {changeLanguage(this.props.siteLanguage, 'please_select_specialization')}
                              </option>
                              {
                                this.state.specializationArr && this.state.specializationArr.length && this.state.specializationArr.filter(elx => elx.appointment_id == el.appointment_id).map(el => (
                                  <option value={el.id}>{el.name_en}</option>
                                ))
                              }
                            </Form.Select>
                            <label style={{ display: this.state.errors["specialization_id" + i] ? 'block' : 'none' }} className="error">{this.state.errors["specialization_id" + i]}</label>
                          </Form.Group>


                          <Button color="danger btn-block" type="button" onClick={() => this.removeDoctor(i)} >
                            <Icon prefix="fa" name="trash" ></Icon>
                          </Button>
                        </Form.FieldSet>
                        <hr />
                      </div>
                    ))}

                    <Button color="outline-primary btn-block" type="button" onClick={(e) => this.addDoctor()} >
                      <Icon prefix="fa" name="plus" ></Icon>
                    </Button>
                    <div>
                      {!this.state.isLoading ?
                        <Button color="primary btn-block" type="submit">{changeLanguage(this.props.siteLanguage, 'create')}</Button>
                        :
                        <Buttonloader loading={this.state.isLoading}></Buttonloader>
                      }
                    </div>
                  </form>
                  <ToastContainer autoClose={5000} position={toast.POSITION.BOTTOM_RIGHT} />
                </Card.Body>
              </Card>
            </Grid.Col>
          </Grid.Row>
        </Page.Content>
      </SiteWrapperHospitalSuperadminReact >
    )
  }

}


const mapStateToProps = (state) => {
  return {
    siteLanguage: state.auth.siteLanguage
  }
}
const bindActions = (dispatch) => {
  return {
    updateToastState: (payload) => dispatch(authActions.updateToastState(payload))
  }
}
export default withRouter(connect(mapStateToProps, bindActions)(DoctorCreate));
//export default ClientCreate;

